import PropTypes from 'prop-types';
import React from 'react';

import HorseRacingNextRaceLine from 'modules/HorseRacing/components/HorseRacingNextRaceLine'

export default function HorseRacingRideSummaryTable(props) {

  const runners = props.runners;

  require('./HorseRacingRideSummaryTable.scss');
  return (
    <div className="next-race-off-list">
    { runners && runners.length > 0
      ?
        runners.map(ride => {
          return (
            <HorseRacingNextRaceLine key={ride.ride_reference.id} ride={ride} raceExternalId={props.raceExternalId} raceSummary={props.raceSummary} eachWay={props.eachWay}
              suspended={props.suspended} fixture={props.fixture}/>
          )}
        )
      :
        <div className="next-race-off-norunners">No listed runners.</div>
    }
    </div>
  );
}

HorseRacingRideSummaryTable.propTypes = {
  runners: PropTypes.array.isRequired,
  raceSummary: PropTypes.object,
  raceExternalId: PropTypes.string,
  eachWay: PropTypes.object,
  suspended: PropTypes.bool,
  fixture: PropTypes.string
};



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/HorseRacingRideSummaryTable.js